import { render, staticRenderFns } from "./CompletaProfilo.vue?vue&type=template&id=39669214"
import script from "./CompletaProfilo.vue?vue&type=script&lang=js"
export * from "./CompletaProfilo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports